import GoogleBtn from "./GoogleBtn";
export default function Dashboard() {
    return(
        <div className="Login">
        <GoogleBtn  /> 
    </div>
    );
}